export const documentDownloadUrl = (
  activeCompanyKey: string,
  documentId: number,
  accessToken: string | null | undefined
) => {
  return `${process.env.REACT_APP_API_URI}document/${documentId}?auth=${accessToken}&activeCompanyKey=${activeCompanyKey}`;
};

export const journalDownloadUrl = (
  blastId: number,
  projectKey: string,
  accessToken: string | null | undefined
) => {
  return `${process.env.REACT_APP_API_URI}v2/projects/${projectKey}/blasts/${blastId}/journal?auth=${accessToken}`;
};

export const imageDownloadUrl = (
  projectKey: string,
  itemId: string,
  accessToken: string | null | undefined
) => {
  return `${process.env.REACT_APP_API_URI}v2/projects/${projectKey}/images/${itemId}/content?auth=${accessToken}`;
};

export const imageThumbnailUrl = (
  projectKey: string,
  itemId: string,
  size: number,
  accessToken: string | null | undefined
) => {
  return `${process.env.REACT_APP_API_URI}v2/projects/${projectKey}/images/${itemId}/thumbnail?size=${size}&auth=${accessToken}`;
};

export const documentItemDownloadUrl = (
  projectKey: string,
  path: string,
  accessToken: string | null | undefined
) => {
  return `${
    process.env.REACT_APP_API_URI
  }v2/projects/${projectKey}/documents/content?path=${encodeURIComponent(
    path
  )}&auth=${accessToken}`;
};

export const albumDownloadUrl = (
  projectKey: string,
  albumId: string,
  accessToken: string | null | undefined
) => {
  return `${process.env.REACT_APP_API_URI}v2/projects/${projectKey}/albums/${albumId}/download?auth=${accessToken}`;
};
